import {
  ChatBulkAuditCardShared,
  ChatBulkAuditSchemaType,
  CHAT_BULK_AUDIT,
} from '@scale/genai-compass-shared/cards/chat_bulk_audit';
import { CompassCardUI } from '@scale/compass-ui/types';
import { faComments } from '@fortawesome/pro-solid-svg-icons';
import ChatBulkAuditCardComponent from './ChatBulkAuditCardComponent';

export const ChatBulkAuditCardInput: CompassCardUI<ChatBulkAuditSchemaType> = {
  ...ChatBulkAuditCardShared,
  title: 'Chat Bulk Audit',
  icon: 'clipboard-check',
  toolTip: 'Audit Tasks/Taskattempts or Contributors',
  defaultContext: {
    cardType: CHAT_BULK_AUDIT,
    objectIds: [],
  },
  button: {
    icon: faComments,
  },
  legacyComponent: ChatBulkAuditCardComponent,
};
